import React from "react";
import { useNavigate } from "react-router-dom";
import "./PurchaseOrders.css";

/**
 * Eski "Operatörler" adresi. Ayrı bir operatör listesi yok: atölye çalışanları kullanıcı hesabıdır
 * ve atölyelere kullanıcı kartından atanır. Sayfa yalnız yön gösterir.
 */
const Operators: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="po-page">
      <header className="po-head">
        <div>
          <span className="po-kicker">Atölye</span>
          <h1>Operatörler</h1>
          <p>Atölye çalışanları ayrı bir listede tutulmuyor.</p>
        </div>
      </header>
      <section className="po-card">
        <div className="po-blank">
          <span className="po-blank-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21h18M5 21V8l6-3v3l6-3v16M9 21v-4h4v4" /></svg>
          </span>
          <b>Operatörler Atölye ekranından yönetilir</b>
          Çalışanlar kullanıcı hesabı olarak tanımlanır ve atölyelere kullanıcı kartından atanır. Atölyeleri, bağlantılarını ve teknikleri Atölye ve Teknikler ekranında düzenleyebilirsiniz.
          <button type="button" className="po-btn primary" onClick={() => navigate("/workshops")}>Atölye ve Teknikler'e git</button>
        </div>
      </section>
    </div>
  );
};

export default Operators;
